/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-vars */
<!-- 预约窗口 -->
<template>
  <div class="dialog-content">
    <el-form
      :rules="rules"
      :model="reservarionformData"
      ref="reservarionform"
      class="demo-ruleForm"
      label-width="80px"
    >
      <el-form-item label="车主名">
        <el-input v-model="userData.cName" :disabled="true" style="width: 50%;"></el-input>
      </el-form-item>
      <el-form-item label="手机">
        <el-input v-model="userData.cPhone" :disabled="true" style="width: 50%;"></el-input>
      </el-form-item>
      <el-form-item label="预约类型" prop="ReservationType">
        <el-select
          v-model="reservarionformData.ReservationType"
          placeholder="请选择"
          style="width: 50%;"
        >
          <el-option v-for="item in rTypes" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择车辆" prop="CarbarnId">
        <el-select v-model="reservarionformData.CarbarnId" placeholder="请选择" style="width: 50%;">
          <el-option
            v-for="item in userData.carbarns"
            :key="item.carId"
            :label="item.brandCode"
            :value="item.carId"
          >
            <span style="float: left">{{ item.brandCode }}</span>
            <span v-if="item.isCheck" style="float: right;  font-size: 13px">已认证</span>
            <span v-if="!item.isCheck" style="float: right; color: #8492a6; font-size: 13px">未认证</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="汽修店" prop="EntpId">
        <el-select
          v-model="reservarionformData.EntpId"
          filterable
          :filter-method="getEntpList"
          @change="getAppointments(reservarionformData.EntpId)"
          placeholder="请选择"
          style="width: 50%;"
        >
          <el-option v-for="item in entpList" :key="item.Id" :label="item.Cn" :value="item.Id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预约日期" class="inline" prop="RDate">
        <el-col :span="8">
          <el-date-picker
            :picker-options="pickerOptions"
            type="date"
            placeholder="选择日期"
            v-model="reservarionformData.RDate"
            value-format="yyyy-MM-dd"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
        <!-- <el-col class="line" :span="0.8">--</el-col> -->
        <el-col :span="8">
          <el-form-item label="时间" prop="RTime">
            <el-select v-model="reservarionformData.RTime" placeholder="选择时间" style="width: 100%;">
              <el-option v-for="item in appointments" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="费用" prop="Fee">
        <el-input type="number" v-model.trim="reservarionformData.Fee" placeholder="上门检修与公路救援必须填写费用" @input="handleInput"></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="Address">
        <el-input
          v-model.trim="reservarionformData.Address"
          maxlength="100"
          placeholder="上门与预约到店必须填写地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="Remark">
        <el-input type="textarea" v-model="reservarionformData.Remark"></el-input>
      </el-form-item>
    </el-form>
    <div style="text-align:right;margin-top:20px;">
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "reservarionDialog",
  props: { cid: String ,entpId: String},
  data() {
    // var validateAddress = (rule, value, callback) => {
    //   if (this.reservarionformData.ReservationType > 0 && value.length == 0) {
    //     callback(new Error("请输入车主所在地址"));
    //   } else {
    //     callback();
    //   }
    // };
    var validateFee = (rule, value, callback) => {
      if (
        this.reservarionformData.ReservationType * 1 > 0 &&
        !(Number(value) > 0)
      ) {
        callback(new Error("请输入有效费用"));
      } else {
        callback();
      }
    };
    return {
      rTypes: [
        { key: 0, value: "到店检修" },
        { key: 1, value: "上门检修" },
        { key: 2, value: "公路救援" }
      ],
      userData: { cName: "", cPhone: "", addr: "", carbarns: [] },
      entpList: [],
      appointments: [],
      reservarionformData: {
        ReservationType: 0,
        CId: "",
        Address: "",
        CarbarnId: "",
        EntpId: "",
        RDate: "",
        RTime: "",
        Fee: "",
        Remark: ""
      },
      rules: {
        EntpId: [
          { required: true, message: "请选择汽修店", trigger: "change" }
        ],
        Remark: [{ required: true, message: "请填写备注", trigger: "blur" }],
        RDate: [{ required: true, message: "请选择日期", trigger: "blur" }],
        RTime: [{ required: true, message: "请选择时间", trigger: "change" }],
        Address: [{ required: true, message: "请填写地址", trigger: "blur" }],
        // Address: [
        //   {
        //     required: false,
        //     validator: validateAddress,
        //     trigger: "blur"
        //   }
        // ],
        Fee: [
          {
            required: false,
            validator: validateFee,
            trigger: "blur"
          }
        ],
        CarbarnId: [
          {
            required: false,
            validator: function(rule, value, callback) {
              if (value == null || value == "") {
                callback(new Error("请选择已认证的车辆"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },

  watch: {
    cid: {
      // eslint-disable-next-line no-unused-vars
      handler(newVal, oldVal) {
        if (newVal != undefined && newVal != null && newVal != "") {
          this.reservarionformData.CId = newVal;
          this.getUserData(newVal);
          this.getEntpList();
        }
      },
      immediate: true
    },
    entpId:{
        // eslint-disable-next-line no-unused-vars
        handler(newVal, oldVal) {
         this.reservarionformData.EntpId = newVal;
         if (newVal) {
           this.getAppointments(newVal);
        }
      },
      immediate: true
    }
  },

  methods: {
    initializationData(cid,entpId) {
      this.reservarionformData.CId = cid;
      this.getUserData(cid);
      this.getEntpList();
      this.reservarionformData.EntpId = entpId;
      if (entpId) {
       this.getAppointments(entpId);
      }
    },
    //获取车主信息
    getUserData(cid) {
      this.resetForm(); //清空数据
      this.axios
        .get("/RepairManagement/GetClientRRInfo", {
          params: { cid: cid },
          data: {}
        })
        .then(response => {
          if (response.data.errcode == 0) {
            this.userData = response.data.data;
            this.reservarionformData.Address = this.userData.addr;
          } else {
            this.userData = { cName: "", cPhone: "", addr: "", carbarns: [] };
            this.reservarionformData.Address = "";
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取汽修店数据
    getEntpList(searchKey) {
      this.axios
        .get("/Common/LoadAutoRepairShops", {
          params: { key: searchKey, page: 1 },
          data: {}
        })
        .then(response => {
          if (response.data.errcode == 0) {
            let data = JSON.parse(response.data.data);
            this.entpList = data.data;
          } else {
            this.entpList = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取汽修店营业时间
    getAppointments(entpId) {
      this.reservarionformData.RTime = "";
      this.appointments = [];
      this.axios
        .get("/RepairManagement/GetAppointments", {
          params: { entpId: entpId },
          data: {}
        })
        .then(response => {
          if (response.data.errcode == 0) {
            this.appointments = response.data.data;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    submitForm() {
      let that = this;
      this.$refs.reservarionform.validate(vaild => {
        if (vaild) {
          this.axios
            .post(
              "/RepairManagement/CreateRepairReservations",
              that.reservarionformData,
            )
            .then(res => {
              var data = res.data.data;
              if (res.data.errcode == 0 && data) {
                that.$util.successMsg("预约成功");
                that.sendFeeForm(data)
                that.closeDialog();
              }
              else {
                that.$util.warningMsg(res.data.errmsg);
                return false;
              }
            })
            .catch(error => {
              that.$message.error("预约失败！");
            });
        }
      });
    },
    // 发送维修单
    sendFeeForm(RRId){
      let data = this.reservarionformData
      if (data.ReservationType == 0){
        return
      }
      else {
        let feeMsg = {
          RName:data.ReservationType == 1?"上门维修费用单":"公路救援费用单",
          SurplusMoney:data.Fee,
          RType:data.ReservationType,
          IsConfirmFee:false,
          RRId:RRId
        }
        this.$store.commit('updateRepairFeeMsg',feeMsg)
      }
    },
    resetForm() {
      // this.cid="";
      this.reservarionformData.RTime = "";
      this.userData = { cName: "", cPhone: "", addr: "", carbarns: [] };
      this.appointments = [];
      if (this.$refs["reservarionform"] != undefined) {
        this.$refs["reservarionform"].resetFields();
        this.$refs["reservarionform"].clearValidate();
      }
    },
    closeDialog() {
      this.resetForm();
      this.$emit("controlReservarionVisible", false);
    },
    // 费用限制
    handleInput(val) {
      if (val && !/^\d+\.?\d{0,2}$/.test(val)) {
        let sptArr = val.split('.')
        this.reservarionformData.Fee = `${sptArr[0]}.${sptArr[1].substr(0, 2)}` * 1
      }
    }
  }
};
</script>
